module.exports = __webpack_public_path__ + "img/nightmares-icon-1.4efa5b10.svg";